import CookieBanner from "../privacity/CookieBanner";
import { FaInstagram, FaTiktok } from "react-icons/fa";

export default function Footer() {
  function loadScript(a) {
    var b = document.getElementsByTagName("head")[0], c = document.createElement("script"); c.type = "text/javascript",
      c.src = "https://tracker.metricool.com/resources/be.js", c.onreadystatechange = a, c.onload = a, b.appendChild(c)
  }
  loadScript(function () { beTracker.t({ hash: "13bfe4a5675ed3da9ee0a264949d286f" }) });
  return (
    <footer className="bg-eryndra-forest text-eryndra-ivory py-8 px-6 text-sm">
      <div className="max-w-5xl mx-auto flex flex-col gap-4 md:flex-row md:justify-between md:items-center">
        {/* Columna 1: Copyright */}
        <div className="text-center md:text-left">
          <p>© {new Date().getFullYear()} Eryndra Eventos</p>

          {/* Redes sociales centradas debajo */}
          <div className="flex justify-center mt-2 gap-4">
            <a href="https://www.tiktok.com/@eryndraeventos" target="_blank" rel="noopener noreferrer" className="hover:text-eryndra-gold">
              <FaTiktok className="w-6 h-6" />
            </a>
            <a href="https://www.instagram.com/eryndraeventos/" target="_blank" rel="noopener noreferrer" className="hover:text-eryndra-gold">
              <FaInstagram className="w-7 h-7" />
            </a>
           
          </div>
        </div>

        {/* Columna 2: Enlaces */}
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-center md:justify-end">
          
          <a href="/aviso-legal" className="hover:text-eryndra-gold">Aviso legal</a>
          <a href="/politica-privacidad" className="hover:text-eryndra-gold">Política de privacidad</a>
          <a href="/politica-cookies" className="hover:text-eryndra-gold">Política de Cookies</a>
          <a href="/faq" className="hover:text-eryndra-gold">FaQ</a>
          <a href="/blog" className="hover:text-eryndra-gold">Blog</a>
        </div>
      </div>

      <CookieBanner />

    </footer>

  );
}
